<template> 
  <div class="modal fade !p-0 overflow-hidden" id="processFailedModal" ref="processFailedModalRef" tabindex="-1"
    aria-labelledby="processFailedModal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content !rounded-[10px] border-0 shadow-lg font-poppins">
        <div class="modal-body !p-[10px]">
          <div class="relative h-[80px] bg-customBlue-100 rounded-[10px]">
            <button type="button" @click="hide"
              class="absolute top-3 right-4 z-50 focus:!outline-none focus:!shadow-none bg-transparent border-0"
              aria-label="Close">
              <img src="../../assets/images/modal-cross-icon.svg" alt="Cross Icon" class="w-[30px] h-[30px]">
            </button>
            <div class="relative w-full h-full flex flex-col items-center justify-center">
              <div class="relative flex justify-between items-center w-full z-10 ps-6 !pe-12">
                <h6 class="m-0 text-[20px] font-poppins font-semibold text-white tracking-wider">
                  Process Payment
                </h6>
              </div>
            </div>
          </div>
          <div class="px-[5px] py-[10px] largeDesktop:py-[20px] min-h-[150px]">
            <div class="pb-[10px] mb-[20px] border-b-[1px] border-[#E5D2B4]">
              <p class="text-[#666666] text-[14px] font-poppins font-normal">We found an outstanding balance of <span
                  class="font-bold">{{ failedInvoices?.total_amount_formatted }}</span>
                on your account. Review the outstanding charges below and complete your payment today to avoid any
                interruption to your service.</p>
              <div class="my-[10px] largeDesktop:my-[20px] flex flex-col gap-[3px]">
                <ul ref="scrollBox"
                  class="list-inline flex flex-col gap-[3px] overflow-y-auto max-h-[200px] tablet:max-h-[250px] landscape:tablet:max-h-[180px] landscape:laptop:max-h-[120px] landscape:largeDesktop:max-h-[350px]">
                  <li v-for="(item, index) in failedInvoices.invoices" v-bind:key="index"
                    class="flex items-center justify-between gap-[10px] text-[#666666] mb-[0] text-[14px] font-poppins font-normal p-[10px] rounded-[5px] bg-[#EFEFEF]/50">
                    <p class="m-0 flex flex-wrap gap-[5px]"><span class="font-bold text-[#2459A8]">{{ item.bundle_name
                        }}</span>
                      ({{ item.agreement_number }})</p>
                    <p class="text-[16px] font-poppins font-normal min-w-max text-[#333333]">${{
                      $helper.formatAmount(item?.amount ?? 0) }}</p>
                  </li>
                </ul>
                <div class="flex items-center justify-between p-[10px] rounded-[5px] bg-[#E5D3B7]/25">
                  <p class="m-0 text-[14px] font-poppins font-bold text-[#333333]">Total Payable</p>
                  <h2 class="m-0 text-[16px] font-poppins font-bold text-[#333333]">{{
                    failedInvoices?.total_amount_formatted }}</h2>
                </div>
              </div>
              <p class="text-[#666666] m-0 text-[14px] font-poppins font-normal">Please ensure your payment method
                is up to date to avoid further interruptions.</p>
            </div>
            <div class="flex items-center justify-between mb-[10px] largeDesktop:mb-[20px]">
              <h2 class="m-0 text-[16px] laptop:text-[18px] font-poppins font-bold text-[#2459A8]">Payment Method</h2>
              <div class="flex items-center gap-[10px] ">

                <button @click="addNewClicked"
                  class="lg:hover:-translate-y-1 lg:hover:scale-[1.02] active:translate-y-0 active:scale-[0.98] group flex items-center gap-[5px] largeDesktop:gap-[10px] rounded-full pl-[5px] py-[5px] pr-[25px] shadow-[0_0_10px_rgba(0,0,0,0.15)] transition duration-300 bg-[#fff] hover:bg-[#B6CE35]">
                  <div
                    class="rounded-full w-[24px] h-[24px] largeDesktop:w-[30px] largeDesktop:h-[30px] flex items-center justify-center shadow-[0_0_10px_rgba(0,0,0,0.15)] border-[1px] border-[#fff] bg-[#B6CE35]">
                    <img src="../../assets/images/plus-white.svg" alt="Plus Icon"
                      class="w-[14px] h-[14px] largeDesktop:w-[18px] largeDesktop:h-[18px] object-cover">
                  </div>
                  <span class="font-poppins text-[14px] font-normal text-[#000] group-hover:text-[#fff]">Add New</span>
                </button>

                <button @click="getCardListing()"
                  class="lg:hover:scale-[1.15] active:scale-[0.98] transition duration-300">
                  <img src="../../assets/images/reset-icon-enable.png" alt="reset Icon"
                    class="w-[30px] h-[30px] largeDesktop:w-[40px] largeDesktop:h-[40px] object-contain">
                </button>
              </div>
            </div>
            <div class="relative">
              <div ref="dropdown" class="relative">
                <button
                  class="p-[5px] flex items-center justify-between w-full rounded-[5px] border-[1px] border-[#CCCCCC]"
                  @click="toggleDropdown">
                  <div class="flex items-center gap-[10px]">
                    <div>
                      <img src="../../assets/images/card-default-icon.svg" />
                    </div>
                    <div class="flex items-center gap-[10px]">
                      <span class="text-[16px] font-poppins text-[#333]"> {{ selectedCard ? `Card ends with -
                        ${selectedCard.last_digits}` : 'Select Card' }}</span>
                      <span class="text-[14px] font-poppins text-[#999]">{{ selectedCard?.is_default == 1 ? '(Default)'
                        :
                        '' }}</span>
                    </div>
                  </div>
                  <i class="fa fa-angle-down !text-[24px]"></i>
                </button>
                <!-- Dropdown Menu -->
                <div v-if="isOpen"
                  class="absolute top-auto left-0 flex flex-col gap-[7px] list-inline mb-0 p-[10px]  shadow-lg rounded-[10px] mt-[5px] largeDesktop:mt-[10px]  bg-[#fff] w-full">
                  <ul
                    class="flex flex-col gap-[3px] list-inline mb-0 max-h-[100px] laptop:max-h-[70px] largeDesktop:max-h-[150px] overflow-y-auto customScrollbar ">
                    <li v-for="(item, index) in paymentCardListing.body" :key="index"
                      class="flex items-center gap-[10px] hover:bg-[#efefef] p-[5px] rounded-[3px]">
                      <div>
                        <img src="../../assets/images/card-default-icon.svg" />
                      </div>
                      <a @click="selectItem(item)"
                        class="w-full text-[14px] largeDesktop:text-[16px] font-poppins text-[#333] flex items-center gap-2">
                        Card ends with - {{ item.last_digits }}
                        <span class="text-[12px] largeDesktop:text-[14px] font-poppins text-[#999]">{{ item.is_default
                          == 1 ? '(Default)' : ''
                          }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="mt-[30px] largeDesktop:mt-[50px] flex flex-row justify-center gap-3">
              <!-- :disabled="!selectedReason || (selectedReason === 'Other' && !otherReason.trim())" -->
              <button @click="payNowClicked"
                class="CustomYellowBtn uppercase w-auto px-[15px] largeDesktop:px-6 py-[5px] largeDesktop:py-2 rounded-full text-[16px] largeDesktop:text-[18px] font-normal transition-all disabled:bg-[#EFEFEF] disabled:hover:bg-gradient-to-r disabled:hover:from-[#EFEFEF] disabled:hover:to-[#EFEFEF] disabled:hover:!text-[#999999] disabled:cursor-not-allowed disabled:!text-[#999999] disabled:!border-[#EFEFEF] ">
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import singleSelectDropdown from '../partialComponent/singleSelectDropdown.vue';
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import { Modal } from 'bootstrap';
import { useToast } from "vue-toastification";
import { settings } from 'nprogress';
const toast = useToast();

export default {
  name: 'CancelClaimModal',
  components: {
    // singleSelectDropdown
  },
  data() {
    return {
      modal: null,
      selectedCard: '',
      isOpen: false,
      isShowModal: false
    };
  },

  props: ["refresh"],

  watch: {
    paymentCardListing: function (data) {

      this.selectedCard = this.getDefaultCard();
      if (this.isShowModal) {
        this.openModal()
      }
    },
    paymentCollectFailResponse: function (data) {
      if (this.paymentCollectFailResponse.length > 0) {
        this.onPaymentFail(this.paymentCollectFailResponse)
      }
    },
    
    paymentCollectResponse: function (data) {
      this.hide()
      this.onPaymentSuccess(this.paymentCollectResponse)
    },

  },

  computed: {
    ...mapGetters(['paymentCardListing', 'failedInvoices','paymentCollectFailResponse','paymentCollectResponse']),

    formattedCardList() {
      if (!this.paymentCardListing) return [];
      return this.paymentCardListing.body.map(reason => {
        if (typeof reason === 'string') {
          return { name: reason };
        }
        return reason;
      });
    },

  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    ...mapActions(['getCardListing' , 'paymentCollect']),

    onPaymentFail(data) {
            //temp dialogue
            this.$dialog.show({
                title: "Payment Failed",
                buttonText: "Dimiss",
                showCross: false,
                html: `
                        <div class="flex flex-col items-center justify-center gap-4 text-gray-700 text-[16px]">
                            <img src=${require('../../assets/images/caution-icon.png')} style="width:60px; height:auto;">
                            <p style="word-break: break-word;" class="text-[14px] m-0"> ${data}</p>
                        </div>`,
                onConfirm: () => {

                },
            });
        },

        onPaymentSuccess(data) {
            //temp dialogue
            this.$dialog.show({
                title: "Payment Successful",
                buttonText: "View Invoice",
                html: `
                    <div class="rounded-lg border border-gray-200 bg-white p-[10px]">
                        <p class="mb-[10px] text-[14px] text-gray-800">
                            Your payment of <span class="font-semibold">${data.total_charged_formatted}</span> has been processed successfully.
                        </p>

                        <div class="space-y-2 text-gray-700 text-left">
                            <p>
                            <span class="text-[12px] font-bold">Invoice Number:</span>
                            <span class="text-[12px] ml-1">${data.stripe_invoice_number}</span>
                            </p>
                        </div>
                    </div>`,
                onConfirm: () => {

                    window.open(data.stripe_invoice_url, '_blank');
                },
            });
        },


    openModal() {
      if (!this.modal) {
        this.modal = new Modal(this.$refs.processFailedModalRef);
      }
      this.modal.show();
      this.$nextTick(() => {
        setTimeout(() => {
          const el = this.$refs.scrollBox;
          el.scrollTo({ top: 0, behavior: "smooth" });
        }, 300); // modal animation wait
      });
      disableScroll();
    },

    async show() {
      this.selectedCard = '';
      this.isShowModal = true
      this.getCardListing()

    },

    hide() {
      this.isShowModal = false
      if (this.modal) {
        this.modal.hide();
      }
      enableScroll();
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },

    selectItem(item) {
      this.selectedCard = item
      this.isOpen = false;
    },

    handleClickOutside(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },

    getDefaultCard() {
      return this.paymentCardListing.body.find(item => item.is_default === "1");
    },

    payNowClicked() {

      let invoices = this.failedInvoices.invoices.map(invoice => invoice.invoice_id)

      this.paymentCollect({
        'invoice_ids': invoices,
        'card_id': this.selectedCard.id
      })
    },

    addNewClicked() {
      const routeData = this.$router.resolve({
        name: 'paymentMethod'
      });

      window.open(routeData.href, '_blank');
    },

  }
};
</script>
